<template>
	<div>
		<h2>{{$t("subject_details.bidding_notice")}}</h2>
		<div class="xuzhi_detail">
			<p class="f20" style="text-indent: 2em;">本《竞拍须知》根据《中华人民共和国民事诉讼法》等相关法律规定所制订，竞买人在竞价前应认真仔细阅读，了解本须知的全部内容。拍卖活动遵循“公开、公平、公正、诚实守信”的原则，拍卖活动具备法律效力。参加本次拍卖活动的竞买人必须遵守本须知的各项条款，并对自己的行为承担法律责任。</p>
			<p class="xuzhi_tit">一、拍卖标的：</p><p class="f16" style="text-indent: 2em;">1.本次竞价项目的转让方：中国联合网络通信有限公司吉林省分公司（以下简称转让人）。
2.转让标的：中国联合网络通信有限公司吉林省分公司  XXXXXXX  报废物资处置项目一批（见附件），买受人自提，拆卸、搬运等费用自理，物资存放地点见附件。
拍卖标的对应的资产外观、结构、固定装修、内在质量及商标的登记状态以移交时的现状为准。生产性设备的实际运行状况以交接时的现状为准，拍卖人对设备外观、质量、结构、维修、运行等情况不作担保。
</p>
			<p class="xuzhi_tit">二、现场查验：</p>
			<p class="f16" style="text-indent: 2em;">本次拍卖是经法定公告期和展示期后才举行的，就拍卖标的物已知及可能存在的瑕疵已在本次拍卖资料中作了详尽的说明。委托人对拍卖标的物所作的说明和提供的视频资料、图片等，仅供竞买人参考，不构成对标的物的任何担保。所以请竞买人在拍卖前必须仔细审查拍卖标的物，调查是否存在瑕疵，认真研究查看所竟买标的物的实际情况，并请亲临展示现场，实地看样，未看样的竞买人慎重决定竞买行为，竞买人一旦作出竞买决定，即表明已完全了解，并接受标的物的现状和一切已知及未知的瑕疵。</p>
			<p class="xuzhi_tit">三、竞买人要求：</p>
			<p>1.凡具备完全民事行为能力的公民、法人和其他组织均可参加竞买，若不具有完全民事行为能力其委托人或代理人必须具备完全民事行为能力。</p>
			<p>2.法律、行政法规、司法解释对买受人资格或者条件有特殊规定的(比如商品房限购等)，竞买人应当具备规定的资格或者条件。因不符合条件参加竞买的，由竞买人自行承担相应的法律责任。</p>
			<p>3.竞买人可委托代理人(具备完全民事行为能力的自然人)进行，但须在竞买开始前与委托人沟通办理委托手续;竞买成功后，竞买人(法定代表人、其他组织的负责人)须与委托代理人一同到委托人处办理交付或权属转移手续。如委托手续不全，竞买活动认定为委托代理人的个人行为。</p>
			<p>4.竞买人注册账户信息时，须提交单位或者个人的相关信息，在拍卖平台审核后才能以其对应的名义参与竞拍，竞买人提供的账号信息与收付保证金的账户信息一致。</p>
			<p class="xuzhi_tit">四、优先购买人：</p>
			<p>1.优先购买权人参加竞买的，标的物竞拍前向委托人提交合法有效的证明，资格经委托人确认后才能参与竞买，逾期不提交的，视为放弃对本标的物享有优先购买权。</p>
			<p>2.优先购买权人参与竞买的，以与其他竞买人以相同的价格出价，没有更高出价的，拍卖财产由优先购买权人竞得。</p>
			<p>3.顺序不同的优先购买权人申请参与竞买的，委托人应当确认其顺序，赋予不同顺序的优先竟买代码。顺序不同的优先购买权人以相同价格出价的，拍卖财产由顺序在先的优先购买权人竞得。顺序相同的优先购买权人以相同价格出价的，拍卖财产由出价在先的优先购买权人竞得。</p>
			<p class="xuzhi_tit">五、拍卖方式：</p>
			<p class="xuzhi-con2">拍卖采取有保留价或无保留价的增价拍卖方式，每次出价金额必须是加价幅度规定金额的整数倍。</p>
			<p>1.有保留价:</p>
			<p>（1）保留价大于起拍价：至少一人报名且出价不低于保留价，方可成交，出价低于保留价时，标的流拍;</p>
			<p>（2）保留价等于起拍价：①一人报名，即视为接受标的底价，已满足成交条件，即可成交。②无人报名，标的流拍。③两人或两人以上报名，均未出价，最先报名成功者判定为买受人。</p>
			<p>2.无保留价:①一人报名，即视为接受标的底价，已满足成交条件，即可成交。②无人报名，标的流拍。③两人或两人以上报名，均未出价，最先报名成功者判定为买受人。</p>
			<p class="xuzhi_tit">六、拍卖延时：</p>
			<p>本次拍卖活动设置延时出价功能，在拍卖活动自由竞价时间过后自动进入限时竞价时间。在限时竞价活动结束前，每最后1分钟如果有竞买人出价，就自动延至1分钟。</p>
			<p class="xuzhi_tit">七、保证金说明：</p>
			<p>1.保证金的缴纳:</p>
			<p>保证金是竞买人参加拍卖的凭证，按着平台指定的付款信息如数交纳保证金。参与本次竞价需交纳竞价保证金大写人民币：              元整（¥            元）。竞价前竞买人确定银行账户是否开通网上银行及银行限额能否满足一次性支付保证金。资产竞价因标的物本身价值，其起始价、保证金、竞价成交价格相对较高，竞买人参与竞价支付保证金及余款时可能会碰到当天限额无法支付的情况，请竞买人根据自身情况选择网上充值银行。</p>
			<p>2.竞拍成功后，买家除支付拍品的货款外还需支付和拍品相关杂费（例如：物流费、拆迁费、人工费、保险费、税费等），买方需要在拍卖之前进行了解，并明确自己应该负担的各项费用，如果在未知晓的情况下竞拍成功，视同已经了解各项费用承担金额。</p>
			<p>A.竞买人未成功竞拍商品:保证金返还时限期为5个工作日；</p>
			<p>B.竞买人竞拍成功后，委托人主动关闭交易或未履约发货或因商家其他原因导致交易未完成的;竞拍结束后，系统会自动在5个工作日内将款项退还到支付账号中；</p>
			<p>C.竞买人缴纳的保证金仅用于履约保证，返还时不计利息，请知悉。</p>
			<p>3.保证金的扣除:买受人在增价拍竞拍成功之时起的3个工作日内，未按照成交价格支付货款的，将承担违约责任并无权要求返还竞价保证金，中国联合网络通信有限公司吉林省分公司有权组织重新竞价。同时，买受人在1年以内不得参加吉林联通乃至中国联通组织的所有报废物资处置业务。情节严重者，列入中国联通供应商黑名单。</p>
			<p>4.违约赔偿:</p>
			<p>A.竞买人竞拍成功并支付成交款后，如因委托人原因出现了“成交不卖”的违规行为，委托人关闭交易或未履约发货，委托人应为竞买人办理退款并承担相应的法律责任。</p>
			<p>B.买受人逾期未支付拍卖余款或未办理交接手续，委托人可提请重新拍卖。重新拍卖时，原买受人不得参加竞买。拍卖成交后买受人悔拍的，交纳的保证金不予退还，依次用于支付拍卖产生的费用损失、弥补重新拍卖价款低于原拍卖价款的差价等。</p>
			<p class="xuzhi_tit">八、保证金说明：</p>
			<p>1.保证金的缴纳：</p>
			<!-- <p>保证金是送拍人、竞拍人参加拍卖的凭证，按着平台指定的付款信息如数交纳保证金（吉林省崇晟科贸有限公司开户行:{{$global.account_bank+$global.account_number}}。</p> -->
			<p>标的成交后，买受人应于标的成交之日起3个工作日内与委托人办理货物交割手续，并由委托人协助办理过户手续，逾期不办理的，承担本标的物可能发生的损毁、灭失等后果。</p>
			<p>竞价成交后，买受人须在15日内与标的物所属分公司完成标的物转让合同签订。若买受人未在规定时间内办理完成签约手续，自行承担由此造成的一切损失和相关责任。若交易双方届时均未在约定的时间内履行处置合同签约手续，由此引发的违约责任由交易双方通过法律途径解决。</p>
			<p>2.买受人完成全额款项支付及合同签订后，必须在合同签订起 60 日内将实物交接完毕（需要办理转运手续的，必须持转运手续进行交接，转运手续由买受人自行办理，费用由买受人自行承担。），超时限的视为无履约能力取消中标资格，扣保证金并视情节扣部分货款，同时1年以内不得参与联通组织的报废物资处置业务，情节严重者，列入中国联通供应商黑名单。请酌情参与。其它事项按合同中有关约定进行。</p>
			<p>3.买受人要按照环保有关规定，规范完成相关手续，因环保手续缺失造成的一切后果由买受人承担，包括但不仅限于，除政府行政处罚外，扣罚保证金，列入中国联通黑名单，承担给联通造成的损失等。</p>
			<p>4.标的物交接现场发生的运输、保险、吊装、拆撤、清理现场等所有费用，均由买受人承担。若由于买受人操作不当等原因，造成拍卖人下属分公司的财产损失，应承担相应赔偿责任。</p>
			<p>5.本次竞价是经法定公告期和展示期后举行的。处置标的物所作的列示、说明、图片等内容，仅供竞买人参考，不构成对标的物的任何担保。本次网络竞价所涉标的物，全部依现场勘察实物现状进行处置。现状是指看样时点标的的质量、数量、新旧程度、使用现状等现实状况，至竞价时点竞买人没有异议，则表示竞买人认可看样时点与竞价时点标的现状一致。合格竞买人在竞价前已经亲临展示现场，实地查看所竞买标的物的实际情况，知悉转让标的所公开披露的全部信息及其可能存在的瑕疵。由此所产生的纠纷（如实物交付时，竞买人以未对标的物做详尽勘察为由，对标的物的交付产生歧义等）中国联合网络通信有限公司吉林省分公司及所属市分公司不承担任何法律责任和赔偿义务。</p>
			<p>6.资产转让过程中出现下列情形的，转让人可以要求立即中止或者终结资产转让活动，同时有权直接做出资产转让活动中止和终结的决定。</p>
			<p>（1）存在违反国家法律法规或其他有关方提出争议情形时；</p>
			<p>（2）在资产交易过程中出现违反各项交易规则、细则等相关规定，并妨碍正常交易秩序的；</p>
			<p>（3）转让人发现转让标的物或转让活动内容存在重大瑕疵的；</p>
			<p>（4）交易双方及相关主体因纠纷争讼，由仲裁机构（或法院）做出中止和终结决定的。</p>
			<p>（5）列入中国联通供应商黑名单禁入期内。</p>
			<p>6）单位负责人为同一人或者存在控股、管理关系的不得同时参与同一项目竞拍。若出现上述情形的竞买人，取消其竞拍资格。</p>
			<p>7.竞买人在竞价期间存在行贿、恶意串通、弄虚作假、泄漏保密信息等不正当行为，一经发现，列入转让人的供应商黑名单。</p>
			<p class="xuzhi_tit">九、其他规定:</p>
			<p>1.因注册信息不准确、资料提供不完善、竞买保证金交纳不及时，造成申请人用户名不能被审核通过，从而不能登录竞价大厅，拍界网络拍卖平台不承担任何责任。</p>
			<p>2.竞买人的竞买账号和密码一经转交给竞买人后，因泄露、丢失、遗忘登录密码而产生的一切后果，拍界网络拍卖平台不承担任何责任。</p>
			<p>3.由于本次拍卖为网络拍卖，竞买人在规定的时间凭账号及密码登陆交易系统进行报价，凡以竞买人的账号和密码登陆交易系统进行的操作，均被视为竞买人的行为，竟买人应当对以其账号进行的所有活动和事件负法律责任。由于网络拍卖对于时间要求的严格性，竞买人在规定时间段内未登录交易系统报价的，视为自愿放弃竞买资格。由于竞买人自身原因导致不能登录交易系统进行报价的，后果由竟买人自行承担。竞买人应当谨慎报价，报价一经提交，不得修改或者撤回。网上交易过程中所涉及的时间，以交易系统服务器时间为准。</p>
			<p>4.由于互联网可能出现不稳定情况，不排除网络竞价发生故障(包括但不限于网络故障、电路故障、系统故障)以及被网络黑客恶意攻击，或因竟买人自身终端设备和网络异常等原因导致无法正常竞价的，拍界网络拍卖平台不承担任何责任。</p>
			<p>5.对于因不可抗力或本系统程序不能控制的因素导致服务中断、报价中断或其他缺陷，拍界网络拍卖平台不承担任何责任。</p>
			<p>6.参加竞买的人应当遵守拍卖须知的规定，不得阻挠其他竞买人竞拍，不得操纵、垄断竞拍价格，严禁竞买人恶意串标，上述行为一经发现，将取消其竞买资格，并追究相关的法律责任。</p>
			<!-- <p class="xuzhi-con2">标的成交后，买受人应于标的成交之日起3个工作日内与送拍人办理货物交割手续，并由管理人协助办理过户手续，逾期不办理的，承担本标的物可能发生的损毁、灭失等后果。</p>
			<p class="xuzhi_tit">十、其他规定：</p>
			<p>1.因注册信息不准确、资料提供不完善、竞买保证金交纳不及时，造成申请人用户名不能被审核通过，从而不能登录竞价大厅，我公司不承担任何责任。</p>
			<p>2.竞买人的竞买账号和密码一经转交给竞买人后，因泄露、丢失、遗忘登录密码而产生的一切后果，我公司不承担任何责任。</p>
			<p>3.由于本次拍卖为网络拍卖，竞买人在规定的时间凭账号及密码登陆交易系统进行报价，凡以竞买人的账号和密码登陆交易系统进行的操作，均被视为竞买人的行为，竞买人应当对以其账号进行的所有活动和事件负法律责任。由于网络拍卖对于时间要求的严格性，竞买人在规定时间段内未登录交易系统报价的，视为自愿放弃竞买资格。由于竞买人自身原因导致不能登录交易系统进行报价的，后果由竞买人自行承担。竞买人应当谨慎报价，报价一经提交，不得修改或者撤回。网上交易过程中所涉及的时间，以交易系统服务器时间为准。</p>
			<p>4.由于互联网可能出现不稳定情况，不排除网络竞价发生故障（包括但不限于网络故障、电路故障、系统故障）以及被网络黑客恶意攻击，或因竞买人自身终端设备和网络异常等原因导致无法正常竞价的，我公司不承担任何责任。</p>
			<p>5.对于因不可抗力或本系统程序不能控制的因素导致服务中断、报价中断或其他缺陷，我公司不承担任何责任。</p>
			<p>6.参加竞买的人应当遵守拍卖须知的规定，不得阻挠其他竞买人竞拍，不得操纵、垄断竞拍价格，严禁竞买人恶意串标，上述行为一经发现，将取消其竞买资格，并追究相关的法律责任。</p> -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'BiaodiIntroduce',
	props: {
		msg: String
	}
}
</script>